import {
  ReadingType,
  ReadingStatus,
  ReadingTemplateRoles,
} from 'infrastructure/enums';

import { freeTextTemplate } from './common';
import * as maYellowTemplates from './ma-yellow';
import * as maGreenTemplates from './ma-green';
import * as nurseYellowTemplates from './nurse-yellow';
import { type TFormItem, type TFormsReadingType } from '../types';

export const greenMaTemplates: Record<TFormsReadingType, TFormItem[]> = {
  [ReadingType.BloodPressure]: maGreenTemplates.bloodPressure,
  [ReadingType.BloodGlucose]: maGreenTemplates.glucose,
  [ReadingType.SpO2]: maGreenTemplates.spo2,
  [ReadingType.Weight]: maGreenTemplates.weight,
  [ReadingType.PeakFlow]: freeTextTemplate(ReadingType.PeakFlow),
  [ReadingType.Temperature]: freeTextTemplate(ReadingType.Temperature),
  [ReadingType.Pulse]: freeTextTemplate(ReadingType.Pulse),
  [ReadingType.SleepingMat]: freeTextTemplate(ReadingType.SleepingMat),
};
export const yellowMaTemplates: Record<TFormsReadingType, TFormItem[]> = {
  [ReadingType.BloodPressure]: maYellowTemplates.bloodPressure,
  [ReadingType.BloodGlucose]: maYellowTemplates.glucose,
  [ReadingType.SpO2]: maYellowTemplates.spo2,
  [ReadingType.Weight]: maYellowTemplates.weight,
  [ReadingType.PeakFlow]: freeTextTemplate(ReadingType.PeakFlow),
  [ReadingType.Temperature]: freeTextTemplate(ReadingType.Temperature),
  [ReadingType.Pulse]: freeTextTemplate(ReadingType.Pulse),
  [ReadingType.SleepingMat]: freeTextTemplate(ReadingType.SleepingMat),
};

export const greenNurseTemplates: Record<TFormsReadingType, TFormItem[]> = {
  [ReadingType.BloodPressure]: freeTextTemplate(ReadingType.BloodPressure),
  [ReadingType.BloodGlucose]: freeTextTemplate(ReadingType.BloodGlucose),
  [ReadingType.SpO2]: freeTextTemplate(ReadingType.SpO2),
  [ReadingType.Weight]: freeTextTemplate(ReadingType.Weight),
  [ReadingType.PeakFlow]: freeTextTemplate(ReadingType.PeakFlow),
  [ReadingType.Temperature]: freeTextTemplate(ReadingType.Temperature),
  [ReadingType.Pulse]: freeTextTemplate(ReadingType.Pulse),
  [ReadingType.SleepingMat]: freeTextTemplate(ReadingType.SleepingMat),
};
export const yellowNurseTemplates: Record<TFormsReadingType, TFormItem[]> = {
  [ReadingType.BloodPressure]: nurseYellowTemplates.bloodPressure,
  [ReadingType.BloodGlucose]: nurseYellowTemplates.glucose,
  [ReadingType.SpO2]: nurseYellowTemplates.spo2,
  [ReadingType.Weight]: nurseYellowTemplates.weight,
  [ReadingType.PeakFlow]: freeTextTemplate(ReadingType.PeakFlow),
  [ReadingType.Temperature]: freeTextTemplate(ReadingType.Temperature),
  [ReadingType.Pulse]: freeTextTemplate(ReadingType.Pulse),
  [ReadingType.SleepingMat]: freeTextTemplate(ReadingType.SleepingMat),
};

type TMaTemplates = typeof greenMaTemplates | typeof yellowMaTemplates | null;

export const maStatusTemplates: Record<ReadingStatus, TMaTemplates> = {
  [ReadingStatus.Normal]: greenMaTemplates,
  [ReadingStatus.Critical]: null,
  [ReadingStatus.Risk]: yellowMaTemplates,
};

type TNurseTemplates =
  | typeof greenMaTemplates
  | typeof yellowNurseTemplates
  | null;

export const nurseStatusTemplates: Record<ReadingStatus, TNurseTemplates> = {
  [ReadingStatus.Normal]: greenMaTemplates,
  [ReadingStatus.Critical]: null,
  [ReadingStatus.Risk]: yellowNurseTemplates,
};

type TRoleTemplates = typeof maStatusTemplates | typeof nurseStatusTemplates;

export const roleTemplates: Record<ReadingTemplateRoles, TRoleTemplates> = {
  [ReadingTemplateRoles.RegisterNurse]: nurseStatusTemplates,
  [ReadingTemplateRoles.MedicalAssistant]: maStatusTemplates,
};
